const BN = require("bignumber.js");
const { BigNumber } = require("ethers");
const ethers = require("ethers");
const constants = require("../constants");

const addressEqual = (addr1, addr2) => addr1.toLowerCase() === addr2.toLowerCase();

const toBN = (ethersBn) => BN(BigNumber.from(ethersBn).toString());

const toEthersBN = (bn) => BigNumber.from(BN(bn).toFixed(0));

const parseJSONorNull = (string) => {
  try {
    return JSON.parse(string);
  } catch (_) {
    return null;
  }
};

const getNetwork = async (provider) => {
  let { chainId } = await provider.getNetwork();
  if (chainId === 31337) {
    const auxProvider = new ethers.providers.JsonRpcProvider(process.env.HARDHAT_FORK_NETWORK);
    const net = await auxProvider.getNetwork();
    chainId = net.chainId;
  }
  return constants.CHAINID_TO_NETWORK_NAME[chainId];
};

const getNetworkConstants = async (provider) => {
  const network = await getNetwork(provider);
  return constants[network];
};

const sortAddresses = (addresses) => addresses.sort((a, b) => {
  const ba = BN(a);
  const bb = BN(b);

  if (ba.gt(bb)) return 1;
  else if (ba.lt(bb)) return -1;
  return 0;
});

const estimateGasPrice = async (provider) => {
  const basePrice = toBN((await provider.getGasPrice()));
  return {
    standard: basePrice.times(1.15),
    fast: basePrice.times(1.2),
    fastest: basePrice.times(2)
  };
};

const quoteWithRouter = async (router, path, amount, slippage = 2) => {
  if (!path.length || path[0].toLowerCase() === path[path.length - 1].toLowerCase() || amount.isZero()) return amount;
  const amountsMin = await router.getAmountsOut(toEthersBN(amount), path);
  return toBN(amountsMin[amountsMin.length - 1]).times(100 - slippage).div(100);
};

const swapPathWithPreferred = (tokenIn, tokenOut, preferred) => {
  if (tokenIn.toLowerCase() === tokenOut.toLowerCase()) return [];
  const path = [tokenIn, preferred, tokenOut];
  if (preferred.toLowerCase() === tokenIn.toLowerCase()) path.shift();
  if (preferred.toLowerCase() === tokenOut.toLowerCase()) path.pop();
  return path;
};

const hasPendingTx = async (provider, address) => {
  const [currentNonce, pendingNonce] = await Promise.all([
    provider.getTransactionCount(address, "latest"),
    provider.getTransactionCount(address, "pending"),
  ]);
  return currentNonce !== pendingNonce;
};

module.exports = {
  addressEqual,
  sortAddresses,
  swapPathWithPreferred,
  parseJSONorNull,
  hasPendingTx,
  toBN,
  toEthersBN,
  estimateGasPrice,
  getNetwork,
  getNetworkConstants,
  quoteWithRouter,
};
